import { withConditionContainer } from '@commons/withCondition';

import HtmlBlock from './HtmlBlock';

export { HtmlBlock };
export default withConditionContainer(HtmlBlock);
